import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import AuthService from "../services/authService";
import logo from "../assets/images/branding/territorio-logo-end.png";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const history = useNavigate();
  const authService = AuthService();

  const handleLogin = async (e) => {
    e.preventDefault();
    const TESTING = false;
    if (!TESTING) {
     
      try {
        let response = await authService.login(username, password);
        console.warn("RESPONSE FROM AUTH SERVICE:",response.success);
        if (response.success) {
          history("/dashboard");
        } else {
          setMessage(response.message);
          console.error('LOGIN ISSUE: '+ response.message);
        }
      } catch (error) {
        console.warn("Error logging in:", error);
      }
    } else {
      const user = "tester";
      localStorage.setItem("site", user);
      history("/dashboard");
    }
  };

  const goHome = () => {
    history("/");
  };

  return (
    <div>
      <div className="login-container">
        <div className="login-hero">
          <img
            src={
              "https://plus.unsplash.com/premium_photo-1678903964473-1271ecfb0288?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            }
            alt="Imagén de Edificios"
          />
        </div>
        <div className="login">
          <img onClick={goHome} className="logo-login" src={logo} alt="Logo" />
          <form onSubmit={handleLogin}>
            <div>
              <input
                type="text"
                value={username}
                placeholder="User name"
                onChange={(e) => setUsername(e.target.value)}
                className="user-input"
                required
              />
            </div>
            <div>
              <input
                type="password"
                value={password}
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                className="password-input"
                required
              />
            </div>
            <div>
              <label>{message}</label>
            </div>
            <button type="submit">Login</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
